import React, { useState } from 'react';
import { Message, MessageContent, MessageHeader, Icon } from 'semantic-ui-react';

import './index.scss';

const InfoMessage = ({type, header='', content=''}) => {
    const [isMessageOpen, setMessageOpen] = useState(true);
    return (
        <>
            {isMessageOpen ?
                <Message
                    className={`InfoMessage${type === 'error' ? '--error':''}`}
                >
                    <MessageContent>
                        <MessageHeader>
                            {header}
                        </MessageHeader>
                        <Icon onClick={()=> setMessageOpen(false)} className='fa-solid fa-xmark' style={{marginRight: 15, cursor: 'pointer'}}/>
                        {content}
                        <Icon onClick={()=> setMessageOpen(false)} className='fa-solid fa-circle-caret-left' style={{float: 'right', cursor: 'pointer', marginTop: 3, marginLeft: 10}}/>
                    </MessageContent>
                </Message> 
            :
            <div className='InfoMessageCaret'>
                <Icon onClick={()=> setMessageOpen(true)} className='fa-solid fa-circle-caret-left' style={{float: 'right', cursor: 'pointer'}}/>
            </div>
            }
        </>
    )
}

export default InfoMessage;